import React from 'react';
import { Row, Col } from 'react-bootstrap';
import LocationInput from './LocationInput';

const LocationSection = ({
  selectLabel,
  formSection,
  deliveryType,
  locationData,
  onLocationChange,
  updateOtherFieldValue,
  formErrors = {},
}) => {
  // Static placeholders for each input field
  const placeholders = {
    locality: 'Locality, City, State, Country',
    city: 'Enter city',
    state: 'Enter state',
    country: 'Enter country',
    zipcode: 'Enter zipcode',
  };

  const handleLocalityChange = (newValue) => {
    const fieldsToReset = [
      'city',
      'state',
      'country',
      'zipcode',
      'latitude',
      'longitude',
    ];
    fieldsToReset.forEach((field) =>
      updateOtherFieldValue('', field, formSection)
    );

    updateOtherFieldValue(newValue, 'locality', formSection);
  };

  return (
    <>
      <Row>
        {/* Locality input only for LOCAL delivery */}
        {deliveryType === 'LOCAL' && (
          <Col xs={12}>
            <LocationInput
              labelText={selectLabel}
              inputName="locality"
              placeholderText={placeholders.locality}
              formSection={formSection}
              value={locationData.locality}
              onLocationChange={onLocationChange}
              updateOtherFieldValue={updateOtherFieldValue}
              errorMessage={formErrors.locality}
              onInputChange={handleLocalityChange}
            />
          </Col>
        )}
      </Row>
    </>
  );
};

export default LocationSection;
